module.exports = __webpack_public_path__ + "static/media/Shells_Landing_Ipad_quickbooks.c70bd297.png";